







































































































import Vue from 'vue';
import ScheduleMsgBox from './ScheduleMsg.vue';
import ScheduleTplMsgDisplay from './ScheduleTplMsgDisplay.vue';
import RemindTimeBox from './RemindTimeBox.vue';
import { ScheduleRuleType } from '../../../models/ScheduleRule';
import { ScheduleMsg, WxTpl, transDiv, transValue } from '../../../models/ScheduleMsg';
import SelectTimeBasedField from './SelectTimeBasedField.vue';
import scheduleRuleVuex from '../../../vuex/common';
import ruleClient from '../../../apis';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    ScheduleMsgBox,
    ScheduleTplMsgDisplay,
    SelectTimeBasedField,
    RemindTimeBox,
  },
  data() {
    return {
      showTimeBasedField: false,
      showRemindTimeBox: false,
      showScheduleMsg: false,
      creating: false,
    };
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        p.propName = '<drip-prop contenteditable="false">#' + p.propName + '</drip-prop>';
        return p;
      });
    },
  },
  methods: {
    hasSetField() {
      return this.scheduleRule.ruleContext.TimeFieldBased.field !== undefined;
    },
    hasSetMsg(): boolean {
      return this.scheduleRule.scheduleMsg !== undefined;
    },
    hasSetRemindTime() {
      return this.scheduleRule.ruleContext.TimeFieldBased.triggerTime !== undefined;
    },
    wxTpl(): WxTpl | null {
      if (this.scheduleRule.scheduleMsg) {
        return this.scheduleRule.scheduleMsg.WxTpl;
      } else {
        return null;
      } 
    },
    wxTemplateId(): string | null {
      return this.wxTpl() ? this.wxTpl()!.templateId : null;
    },
    confirmCreate() {
      if (this.validateCreate()) {
        this.creating = true;
        if (this.scheduleRule.scheduleMsg.WxTpl) {
          const keys = Object.keys(this.scheduleRule.scheduleMsg.WxTpl.params);
          keys.forEach((i) => {
            this.scheduleRule.scheduleMsg.WxTpl.params[i].value = transDiv(transValue(this.tranProps, this.scheduleRule.scheduleMsg.WxTpl.params[i].value));
          });
        }
        const queries = {
          ruleName: this.scheduleRule.ruleName!,
          ruleType: ScheduleRuleType.TimeField,
          ruleContext: this.scheduleRule.ruleContext,
          scheduleMsg: this.scheduleRule.scheduleMsg!,
        };
        if (this.scheduleRule.id) {
          (queries as any)['id'] = this.scheduleRule.id;
          ruleClient.updateRule(queries).success(r => {
            this.$Message.success('修改成功');
            setTimeout(() => {
              this.$emit('success');
            }, 100);
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
            this.creating = false;
          }).error((e) => {
            this.$Message.error(e.toString());
            this.creating = false;
          });
        } else {
          ruleClient.createRule(queries).success(r => {
            this.$Message.success('创建成功');
            setTimeout(() => {
              this.$emit('success');
            }, 100);
          }).failure((code: string, msg?: string) => {
            this.$Message.error(msg);
            this.creating = false;
          }).error((e) => {
            this.$Message.error(e.toString());
            this.creating = false;
          });
        }
      }
    },
    validateCreate() {
      if (this.showTimeBasedField ||
        this.scheduleRule.ruleContext.TimeFieldBased.field === undefined) {
        this.$Message.warning('请设置日期字段');
        return false;
      } else if (this.showRemindTimeBox ||
        this.scheduleRule.ruleContext.TimeFieldBased.triggerTime === undefined) {
        this.$Message.warning('请设置提醒时间');
        return false;
      } else if (this.showScheduleMsg ||
        this.scheduleRule.scheduleMsg === undefined) {
        this.$Message.warning('请设置模板消息');
        return false;
      } else {
        return true;
      }
    },
    updateScheduleRuleName(event: Event) {
      this.$store.commit('UPDATE_SCHEDULE_RULE_NAME', (event.target as any )['value']);
    },
  },
});
